import { render, staticRenderFns } from "./user_order.vue?vue&type=template&id=70b661a9&scoped=true"
import script from "./user_order.vue?vue&type=script&lang=js"
export * from "./user_order.vue?vue&type=script&lang=js"
import style0 from "./user_order.vue?vue&type=style&index=0&id=70b661a9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b661a9",
  null
  
)

export default component.exports